import { useContext, useEffect, useMemo, useState } from 'react';
import { Signal } from '@styled-icons/fa-solid';
import copyIcon from '../../images/copyIcon.png';
import { getHeaderValues } from './QAChecklistTab/utils';
import IpaffsModalReadOnly from '../ipaffs/IpaffsModalReadOnly';
import { StoreContext } from '../Store';
import { getListLoad } from '../apiCalls';

const BILL_TYPES = {
  10: 'Headers',
  20: 'Rows',
};

const LoadConfirmation = ({
  visible,
  newLoadAction,
  listLoadAction,
  statusAction,
  titleText,
  bodyText,
  portalRef,
  isSubmitted,
  products,
  billableType = 20,
}) => {
  const store = useContext(StoreContext);

  const [buttonText, setButtonText] = useState('Copy Ref');
  const [showIpaffsModal, setShowIpaffsModal] = useState(false);
  const [requestFailed, setRequestFailed] = useState(false);
  const [items, setItems] = useState([]);

  const loadId = store.loadId[0];

  useEffect(() => {
    async function fetchData() {
      try {
        const data = await getListLoad('items', loadId);
        setItems(data.Newload[0].Items);
      } catch (err) {
        setRequestFailed(true);
      }
    }
    if (loadId && visible) fetchData();
  }, [loadId, visible]);

  const returnData = useMemo(() => {
    const i = items?.map((row, index) => {
      const newRow = { ...row };
      newRow.Item = index + 1;

      //format data to always show 2 decimal places; to match consistency in the totals
      newRow['Gross mass (kg)'] = newRow['Gross mass (kg)'] ? parseFloat(newRow['Gross mass (kg)']).toFixed(2) : '-';
      newRow['hsCode'] = newRow['HS Code (10)'];
      return newRow;
    });
    return i;
  }, [items?.length]);

  const handleCopyRef = () => {
    navigator.clipboard.writeText(portalRef);
    setButtonText('Copied');
  };

  if (requestFailed) return <p>Failed!</p>;

  return (
    <div className="p-4 d-flex flex-column align-items-center " style={{ marginTop: '4rem', marginRight: '4rem' }}>
      <IpaffsModalReadOnly
        show={showIpaffsModal}
        onHide={() => setShowIpaffsModal(false)}
        ipaffsCategories={store.ipaffsCategories[0]}
        certificateCount={store.certificateCount[0]}
        data={returnData?.filter((i) => i.categoryOption)}
        isConsolidatedTab={true}
      />

      <h1 style={{ color: '#fff' }}>{titleText}</h1>
      <div className="tick-success-large" style={{ marginTop: '0.2rem', marginBottom: '1rem' }}></div>
      <p style={{ fontSize: '110%', color: '#fff' }}>{`${portalRef || ''} ${bodyText}`}</p>

      {isSubmitted && (
        <p style={{ fontSize: '110%', color: '#fff', fontWeight: 'bold' }}>
          Number of {BILL_TYPES[billableType]}: {billableType === '10' ? getHeaderValues(products) : products.length}
        </p>
      )}

      <div className="gap-3 d-flex mb-3">
        <button onClick={handleCopyRef} className="btn_submitted_copy_ref">
          <img src={copyIcon} alt="copy icon" />
          <p>{buttonText}</p>
        </button>
        {isSubmitted && statusAction && (
          <button onClick={statusAction} className="btn_submitted_copy_ref">
            <Signal width="20" height="20" style={{ color: '#fff', marginTop: '6px' }} />
            <p>Status</p>
          </button>
        )}
      </div>
      <div className="gap-3 d-flex ">
        <button className="blue-button-newload" style={{ width: 'auto' }} onClick={newLoadAction}>
          New Load
        </button>
        <button className="blue-button-newload" style={{ width: 'auto' }} onClick={listLoadAction}>
          List Loads
        </button>

        {titleText === 'Saved as Draft' && (
          <button className="blue-button-newload" style={{ width: 'auto' }} onClick={() => setShowIpaffsModal(true)}>
            Check IPAFFS
          </button>
        )}
      </div>
    </div>
  );
};

export default LoadConfirmation;
